import { createSelector } from 'reselect';

const selectmenuitem = state => state.menuItem;

export const selectMenuItem = createSelector(
    [selectmenuitem],
    (category) => category.menuItem
)

export const selectMenuList = catId =>(     
    createSelector ( 
    [selectMenuItem],
    (Items) => Items ? (Items.filter(item => item.category_main === catId)): null,
     )
)

export const selectMenuLoading = createSelector(
    [selectmenuitem],
    (category) => category.isMenuLoading
)